export function app_runtime(base, location) {
	let get_params_init 
	try {
		get_params_init = new URLSearchParams(location.search);
	} catch(e) {}

	let ref_init
	try {
		ref_init = document.referrer && location.host != new URL(document.referrer).host && document.referrer
	} catch (e) {}

	const dflt = { 
			name:'WeWordle',
			app:'ww',
			mode:'ww',
			logo:'images/wewo%20logo.png',

			login_type: ['page', 'popup'][1],

			// optim: {'1_JCh2sTTQK-Qht3c21KoQ':1},
		}
	let extra = {}

	//	------------------------	------------------------	------------------------
	//	------------------------	------------------------	------------------------
	//		partners

	if (location.href.startsWith('https://c2u.wewordle.com/') || location.pathname.startsWith('/c2u')) 
		extra = { 
			partn_type: 'c2u',
			mode: 'c2u',
			partn_oid:'qrGpLwI',
			partn_pharm_oid: 'qrGpLwI',
			partn_pharm_detmsg: 'Your game progress will be synced. Following completion of the setup, proceed to play your favorite word puzzles.',
			start_page:'/c',
			// hide_nav: true,
			// med_allow_nouser: true,
			medbuy_only: true,
		}

	else if (get_params_init?.get('poid')) 
		extra = { 
			// partn_type: 'HE',
			partn_oid: get_params_init?.get('poid'),
			// start_page:'/cat',
			// med_allow_nouser: true,
			// medcert_allow_nouser: true,
			// hide_consults: true,
			// phapick_only: true,
		}

	//	------------------------	------------------------	------------------------
	//	------------------------	------------------------	------------------------
	//		pharms

	else if (get_params_init?.get("phoid") && get_params_init.get("m")=='mbo')
		extra = { 
			partn_type: 'forpha',
			partn_oid:get_params_init.get("phoid"),
			partn_pharm_oid:get_params_init.get("phoid"),
			med_allow_nouser: true,
			start_page:'/cat',
			is_bare: true,
			allow_set_usr: true,
			// free_consult: true,
			medbuy_only: true,
		}


	//	------------------------	------------------------	------------------------
	//	------------------------	------------------------	------------------------
	//		mini sites

	else if (['cosmapp.wewordle.com', 'icosm.test:9011','instcosm.web.app','instcosm.firebaseapp.com', 'instantcosmetic.com.au', 'instantcosmetics.com.au', 'icosm.com.au'].includes(location.host) || location.pathname.toLowerCase().startsWith('/icosmws') )
		extra = { 
			name:'InstantCosmetics',
			app:'icosm',
			mode:'icosm',
			logo:'icosm/images/icosm-header.svg',
			headerLogo:'/icosm/images/icosm-white.svg',
			sidemenuLogo:'/icosm/images/icosm-header.svg',
			scripts:['//unpkg.com/aos@2.3.1/dist/aos.js?ver=5.4.2'],
			css:["https://use.typekit.net/bps3jzd.css"]
		}

	else if (['ilegal.test:9011','ilegal.web.app', 'ilegal.firebaseapp.com', 'mylegaldoc.com.au'].includes(location.host) || location.pathname.toLowerCase().startsWith('/ilegws'))
		extra = { 
			name:'My Legal Doc',
			app:'ileg',
			mode:'ileg',
			headerLogo:'/ileg/images/ileg-logo.svg',
			sidemenuLogo:'/ileg/images/ileg-white.svg',
			css:["/ileg/fonts.css"],
			med_allow_excl: true,
			// medbuy_only: true,
		}

	else if (['icann.test:9011','icanna.web.app', 'icanna.firebaseapp.com', 'thegreendoc.com.au', 'greendoc.com.au', 'goodleaf.com.au', 'goodleaf.au', 'benicura.com.au', 'benicura.au'].includes(location.host) || location.pathname.toLowerCase().startsWith('/icannws'))
		extra = { 
			name:'Benicura',
			app:'icann',
			mode:'icann',
			headerLogo:'/icann/images/logo_withtagline.svg',
			sidemenuLogo:'/icann/images/logo-transparent.svg',
			css:["/icann/fonts.css", "https://use.typekit.net/nxz6kzj.css"],
			incl_med_cat: [/*'DocConsICann', */'DocConsICannFU'],
			// med_allow_excl: true,
			medbuy_only: true,
			logoSize:{
				width:'150px',
				height:'auto'
			},
		}
	
	//	------------------------	------------------------	------------------------
	//	------------------------	------------------------	------------------------
	//		partners

	else if (['dk.test:9011', 'dk.au'].includes(location.host) || location.pathname.toLowerCase().startsWith('/dkws') || get_params_init?.get("phoid")=='cqWhpAM')
		extra = { 
			name: 'Kisla Care',
			app: 'iscr',
			mode: 'dK',
			headerLogo: '/images/icons png-01.png',
			sidemenuLogo: '/images/icons png-01.png',
			css: ["/icann/fonts.css", "https://use.typekit.net/nxz6kzj.css"],
			// incl_med_cat: ['DocConsICann', 'DocConsICannFU'],
			// med_allow_excl: true,
			// medbuy_only: true,
			logoSize:{
				width:'150px',
				height:'auto'
			},
		}

	//	------------------------	------------------------	------------------------

	else if ( ['cbls.test:9011', 'is-cbls.web.app', 'cbls.au', 'cbls.iscr.au', 'bls.iscr.au', 'blsclinics.com.au'].includes(location.host) || location.pathname.toLowerCase().startsWith('/cblsws') || get_params_init?.get("poid")=='szgbqzk' || get_params_init?.get('pnm')?.toLowerCase()=='cbls' )
		extra = { 
			name: 'BLS Clinics',
			app: 'icann',
			mode: 'cbls',
			partn_oid: 'szgbqzk',
			incl_med_cat: ['DocConsICann-cbls', 'DocConsICannFU-cbls'],
			medbuy_only: true,
			// med_allow_excl: true,

			headerLogo:'/icann/cbls/images/BLS-Clinics-logo.png',
			sidemenuLogo:'/icann/cbls/images/BLS-Clinics-logo-white.png',
			css:["/icann/cbls/fonts.css", "https://use.typekit.net/nxz6kzj.css"],
			logoSize:{
				width:'150px',
				height:'auto'
			},

			// headerLogo: 'https://cdn.shopify.com/s/files/1/0599/1602/5913/files/Untitled-1_ed027b37-418c-4453-8cd5-069d22e0862d.png?v=1668037300&width=500',
			// sidemenuLogo: 'https://cdn.shopify.com/s/files/1/0599/1602/5913/files/Untitled-1_ed027b37-418c-4453-8cd5-069d22e0862d.png?v=1668037300&width=500',
		}

	//	------------------------	------------------------	------------------------

	else if ( ['prh.test:9011'].includes(location.host) || location.pathname.toLowerCase().startsWith('/prhws') || get_params_init?.get("poid")=='G3G1ZVQ' || get_params_init?.get('pnm')?.toLowerCase()=='prh' )
		extra = { 
			partn_oid: 'G3G1ZVQ',
			incl_med_cat: ['-NQi3kEk3nXo4hjWK3-V','-NRecaAbZYaXNw3N0EKb'],
		}

	//	------------------------	------------------------	------------------------

	get_params_init?.get("phoid")
		&& (base.partn_pharm_oid = get_params_init.get("phoid"))

	return {...dflt, ...base, ...extra, get_params_init, init_params_obj:Object.fromEntries(get_params_init), ref_init}
}
